import { useTranslation } from "react-i18next";
import riddles from "../data/riddles.json";

export const useDataProvider = () => {
    const { i18n } = useTranslation();
    const currLang = i18n.language;

    const getRiddle = (index) => { return { ...riddles[index].langs[currLang], id: riddles[index].id, qrCode: riddles[index].qrCode } };
    const riddleCount = riddles.length;

    return { getRiddle, riddleCount };
}

export default useDataProvider;  